// extracted by mini-css-extract-plugin
export default {"svg":"discord_svg__sbPv-","test":"discord_test__Iu+sw"};